<ng-container *ngIf="vm$ | async as vm">
	<div class="space-y-2">
		<div
			class="space-y-6 flex"
			[ngClass]="vm.orientation === 'horizontal' ? 'flex-row' : 'flex-col'"
		>
			<div class="flex flex-1 flex-col space-y-2">
				<span class="text-sm font-normal">Funding Option</span>
				<app-dropdown
					[disabled]="vm.isWireTransferOnly"
					[placeholder]="'Select funding option'"
					(onSelect)="onSelectFundingType($event)"
					[ngModel]="vm.selectedFundingTypeText"
					name="funding"
					[required]="true"
					[itemGroups]="[{ items: vm.fundingTypeOptions }]"
				></app-dropdown>
			</div>
			<ng-container *ngIf="vm.isWireTransfer">
				<div class="flex flex-1 flex-col space-y-2">
					<ng-container *ngTemplateOutlet="trustAccount"></ng-container>
				</div>
			</ng-container>

			<div
				*ngIf="displayLocalBranch$ | async"
				class="flex flex-1 flex-col space-y-2"
			>
				<ng-container *ngTemplateOutlet="localBranch"></ng-container>
			</div>

			<ng-container *ngIf="vm.isCourier" class="flex flex-1 flex-col space-y-2">
				<div class="flex flex-1 flex-col space-y-2">
					<span class="text-sm font-normal"
						>Courier Account Number (Purolator)</span
					>
					<app-input
						[placeholder]="'Enter Purolator account number'"
						[ngModel]="vm.accountNumber"
						(debounce)="onAccountNumberChanged($event)"
						name="courierCompany"
						[required]="true"
					></app-input>
				</div>
			</ng-container>
			<ng-container *ngIf="vm.hasBridgeFunding">
				<div class="flex flex-1 flex-col space-y-2">
					<span class="text-sm font-normal">Bridge Funding Required</span>
					<app-radio-group
						[items]="bridgeOptions"
						(ngModelChange)="onBridgeOptionChanged($event)"
						[(ngModel)]="vm.bridgeSelected"
						name="bridge"
						type="compact"
					></app-radio-group>
				</div>
			</ng-container>
		</div>
	</div>

	<ng-template #trustAccount>
		<div *ngIf="trustAccounts$ | async" class="space-y-2">
			<span class="text-sm font-normal">Trust Account</span>
			<app-dropdown
				[placeholder]="'Select an account'"
				(onSelect)="onSelectTrustAccount($event)"
				[ngModel]="vm.selectedTrustAccount?.name"
				name="trustAccount"
				[required]="true"
				[itemGroups]="[{ items: vm.trustAccountOptions }]"
			></app-dropdown>

			<ng-container>
				<div class="flex flex-row items-center align-middle">
					<app-anchor
						class="text-green-600 cursor-pointer"
						(click)="create(DrawerType.TRUST_ACCOUNT)"
					>
						<div
							class="space-x-2 flex flex-row items-center align-middle text-sm"
						>
							<i-tabler name="plus" class="h-4 w-4"></i-tabler>
							<span> Add a new trust account </span>
						</div>
					</app-anchor>
				</div>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #localBranch>
		<div *ngIf="localBranches$ | async" class="space-y-2">
			<span class="text-sm font-normal">Local Branch</span>
			<app-dropdown
				[placeholder]="'Select a branch'"
				(onSelect)="onSelectLocalBranch($event)"
				[ngModel]="vm.selectedLocalBranch?.name"
				name="localBranch"
				[required]="true"
				[itemGroups]="[{ items: vm.localBranchOptions }]"
			></app-dropdown>
			<ng-container>
				<div class="flex flex-row items-center align-middle">
					<app-anchor
						class="text-green-600 cursor-pointer"
						(click)="create(DrawerType.LOCAL_BRANCH)"
					>
						<div
							class="space-x-2 flex flex-row items-center align-middle text-sm"
						>
							<i-tabler name="plus" class="h-4 w-4"></i-tabler>
							<span> Add a new local branch </span>
						</div>
					</app-anchor>
				</div>
			</ng-container>
		</div>
	</ng-template>

	<mat-drawer-container
		[hasBackdrop]="true"
		class="fixed h-screen w-full z-modal top-0 right-0"
		[ngClass]="{ 'pointer-events-none': vm.isFullyClosed }"
	>
		<mat-drawer
			#drawer
			mode="over"
			position="end"
			(openStart)="openDrawer()"
			(closedStart)="closeDrawer()"
		>
			<ng-container *ngIf="!vm.isFullyClosed">
				<div class="p-8 h-full" [ngSwitch]="currentDrawer">
					<app-add-edit-trust-account
						(onTrustAccountCreated)="onTrustAccountCreated($event)"
						*ngSwitchCase="DrawerType.TRUST_ACCOUNT"
						[trustAccountId]="id"
						(onClose)="drawer.close()"
					></app-add-edit-trust-account>
				</div>
			</ng-container>
		</mat-drawer>
	</mat-drawer-container>
</ng-container>
